export default {
    'en': {
        yes: 'Yes',
        no: 'no',
        login: 'Log in',
        or: 'or',
        save: 'Save',
        cancel: 'Cancel',
        error: 'Error',
        name: 'Name',
        dashboard: 'Dashboard',
        optional: 'Optional',
        settings: 'Settings',
        language: 'Language',
        languages: 'Languages',
        german: 'German',
        english: 'English',
        copied: 'copied',
        copy_clipboard: 'Copy to clipboard',
        id: 'ID',
        edit: 'Edit',
        address: 'Address',
        zipcode: 'Zipcode',
        city: 'City',
        country: 'Country',
        add: 'Add',
        delete: 'Delete',
        not_found_title: '404!',
        not_found_content: 'Please try another page.',
        not_found_btn: 'Move on...',
        search_help_title: 'Search tips',
        search_help_text: 'Separate search terms with commas. You can search by name, branding, booking status, agency, or date and combine them freely.',
        search_help_ex1: 'Search by branding',
        search_help_ex2: 'Search by client name',
        search_help_ex3: 'Search by booking status',
        search_help_ex4: 'Client name and start date',
        search_help_ex5: 'Trips starting between these dates',
        search_help_ex6: 'Branding and date range combined',
        search_help_formats: 'Supported date formats: 04 Sep 2026, 04/09/2026, 04.09.2026, 2026-09-04',
    },
    'de': {
        yes: 'Ja',
        no: 'Nein',
        login: 'Login',
        or: 'oder',
        save: 'Speichern',
        cancel: 'Abbrechen',
        error: 'Error',
        name: 'Name',
        dashboard: 'Dashboard',
        optional: 'Optional',
        settings: 'Einstellungen',
        language: 'Sprache',
        languages: 'Sprachen',
        german: 'Deutsch',
        english: 'Englisch',
        copied: 'Kopiert',
        id: 'ID',
        edit: 'Bearbeiten',
        address: 'Adresse',
        zipcode: 'Postleitzahl',
        city: 'Stadt',
        country: 'Land',
        add: 'Hinzufügen',
        delete: 'Löschen',
        not_found_title: '404!',
        not_found_content: 'Bitte probiere eine anderen Seite.',
        not_found_btn: 'Weiter gehts...',
        search_help_title: 'Suchtipps',
        search_help_text: 'Suchbegriffe mit Komma trennen. Sie können nach Name, Branding, Buchungsstatus, Agentur oder Datum suchen und frei kombinieren.',
        search_help_ex1: 'Suche nach Branding',
        search_help_ex2: 'Suche nach Kundenname',
        search_help_ex3: 'Suche nach Buchungsstatus',
        search_help_ex4: 'Kundenname und Startdatum',
        search_help_ex5: 'Reisen mit Startdatum zwischen diesen Daten',
        search_help_ex6: 'Branding und Datumsbereich kombiniert',
        search_help_formats: 'Unterstützte Datumsformate: 04 Sep 2026, 04/09/2026, 04.09.2026, 2026-09-04',
    },
    'fr': {
        yes: 'Oui',
        no: 'Non',
        login: 'Connexion',
        or: 'ou',
        save: 'Enregistrer',
        cancel: 'Annuler',
        error: 'Erreur',
        name: 'Nom',
        dashboard: 'Tableau de bord',
        optional: 'Optionnel',
        settings: 'Paramètres',
        language: 'Langue',
        languages: 'Langues',
        german: 'Allemand',
        english: 'Anglais',
        copied: 'copié',
        copy_clipboard: 'Copier dans le presse-papiers',
        id: 'ID',
        edit: 'Modifier',
        address: 'Adresse',
        zipcode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        add: 'Ajouter',
        delete: 'Supprimer',
        not_found_title: '404 !',
        not_found_content: 'Veuillez essayer une autre page.',
        not_found_btn: 'Continuer...',
        search_help_title: 'Astuces de recherche',
        search_help_text: 'Séparez les termes par des virgules. Vous pouvez rechercher par nom, branding, statut de réservation, agence ou date et les combiner librement.',
        search_help_ex1: 'Recherche par branding',
        search_help_ex2: 'Recherche par nom de client',
        search_help_ex3: 'Recherche par statut de réservation',
        search_help_ex4: 'Nom du client et date de début',
        search_help_ex5: 'Voyages commençant entre ces dates',
        search_help_ex6: 'Branding et plage de dates combinés',
        search_help_formats: 'Formats de date supportés : 04 Sep 2026, 04/09/2026, 04.09.2026, 2026-09-04',
    },
    'nl': {
        yes: 'Ja',
        no: 'Nee',
        login: 'Inloggen',
        or: 'of',
        save: 'Opslaan',
        cancel: 'Annuleren',
        error: 'Fout',
        name: 'Naam',
        dashboard: 'Dashboard',
        optional: 'Optioneel',
        settings: 'Instellingen',
        language: 'Taal',
        languages: 'Talen',
        german: 'Duits',
        english: 'Engels',
        copied: 'Gekopieerd',
        copy_clipboard: 'Kopieer naar klembord',
        id: 'ID',
        edit: 'Bewerken',
        address: 'Adres',
        zipcode: 'Postcode',
        city: 'Stad',
        country: 'Land',
        add: 'Toevoegen',
        delete: 'Verwijderen',
        not_found_title: '404!',
        not_found_content: 'Probeer een andere pagina.',
        not_found_btn: 'Ga verder...',
        search_help_title: 'Zoektips',
        search_help_text: 'Scheid zoektermen met komma\'s. U kunt zoeken op naam, merk, boekingsstatus, agentschap of datum en vrij combineren.',
        search_help_ex1: 'Zoeken op merk',
        search_help_ex2: 'Zoeken op klantnaam',
        search_help_ex3: 'Zoeken op boekingsstatus',
        search_help_ex4: 'Klantnaam en startdatum',
        search_help_ex5: 'Reizen die tussen deze datums starten',
        search_help_ex6: 'Merk en datumbereik gecombineerd',
        search_help_formats: 'Ondersteunde datumformaten: 04 Sep 2026, 04/09/2026, 04.09.2026, 2026-09-04',
    },
    'el': {    yes: 'Ναι',
        no: 'Όχι',
        login: 'Σύνδεση',
        or: 'ή',
        save: 'Αποθήκευση',
        cancel: 'Άκυρο',
        error: 'Σφάλμα',
        name: 'Όνομα',
        dashboard: 'Πίνακας ελέγχου',
        optional: 'Προαιρετικό',
        settings: 'Ρυθμίσεις',
        language: 'Γλώσσα',
        languages: 'Γλώσσες',
        german: 'Γερμανικά',
        english: 'Αγγλικά',
        copied: 'Αντιγράφηκε',
        copy_clipboard: 'Αντιγραφή στο πρόχειρο',
        id: 'ID',
        edit: 'Επεξεργασία',
        address: 'Διεύθυνση',
        zipcode: 'Τ.Κ.',
        city: 'Πόλη',
        country: 'Χώρα',
        add: 'Προσθήκη',
        delete: 'Διαγραφή',
        not_found_title: '404!',
        not_found_content: 'Παρακαλώ δοκιμάστε άλλη σελίδα.',
        not_found_btn: 'Συνεχίστε...',
        search_help_title: 'Συμβουλές αναζήτησης',
        search_help_text: 'Χωρίστε τους όρους αναζήτησης με κόμματα. Μπορείτε να αναζητήσετε κατά όνομα, branding, κατάσταση κράτησης, πρακτορείο ή ημερομηνία και να τα συνδυάσετε ελεύθερα.',
        search_help_ex1: 'Αναζήτηση κατά branding',
        search_help_ex2: 'Αναζήτηση κατά όνομα πελάτη',
        search_help_ex3: 'Αναζήτηση κατά κατάσταση κράτησης',
        search_help_ex4: 'Όνομα πελάτη και ημερομηνία έναρξης',
        search_help_ex5: 'Ταξίδια που ξεκινούν μεταξύ αυτών των ημερομηνιών',
        search_help_ex6: 'Branding και εύρος ημερομηνιών σε συνδυασμό',
        search_help_formats: 'Υποστηριζόμενες μορφές ημερομηνίας: 04 Sep 2026, 04/09/2026, 04.09.2026, 2026-09-04',
    }

}